import React, { useEffect, useState } from 'react';
import { ApiHit } from '../../Api/ApiHit';
import { useDispatch, useSelector } from 'react-redux';
import AddRole from './AddRole';
import { searchRole } from '../../Constant/Constant';
import { setApiJson } from '../../Redux/Actions/ApiAction';
import { setRolesAndPermission } from '../../Redux/Actions/RoleAction';
import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Loader2 } from 'lucide-react';

function EditRole() {
    const dispatch = useDispatch();
    const { id: urlId } = useParams();
    const RoleReducer = useSelector((state) => state.RolesAndPermissionReducer);
    const [isLoading, setIsLoading] = useState(true);
    const [roleData, setRoleData] = useState(null);

    useEffect(() => {
        if (urlId) {
            fetchRole();
        }
    }, [urlId]);

    const fetchRole = () => {
        setIsLoading(true);

        const json = {
            page: 1,
            limit: 1,
            search: {
                _id: urlId
            }
        };

        ApiHit(json, searchRole).then((res) => {
            if (res?.statusCode === 200 && res?.data?.docs?.length > 0) {
                const roleDoc = res?.data?.docs?.[0];

                // Set role basic info for form
                const apiJsonData = {
                    role: roleDoc?.roleName,
                    roleType: roleDoc?.roleType,
                    status: roleDoc?.status || "active",
                    _id: roleDoc?._id
                };
                dispatch(setApiJson(apiJsonData));

                // Store the complete role data
                setRoleData(roleDoc);

                // Recreate permissions structure from fetched role data
                const recreatedPermissions = recreatePermissionsFromRole(roleDoc, RoleReducer?.doc);

                // Dispatch permissions to RoleReducer
                dispatch(setRolesAndPermission(recreatedPermissions));

            } else {
                toast.error('Role not found');
            }
        }).catch((error) => {
            console.error("Error fetching role:", error);
            toast.error('Failed to load role data');
        }).finally(() => {
            setIsLoading(false);
        });
    };

    // Function to recreate permission structure matching AllPermissionList format
    const recreatePermissionsFromRole = (roleData, defaultPermissions) => {
        if (!roleData?.permission || !defaultPermissions) return defaultPermissions;

        return defaultPermissions.map(defaultItem => {
            // Find matching permission in role data
            const existingItem = roleData.permission.find(p => p.value === defaultItem.value);

            if (!existingItem) return defaultItem;

            return {
                ...defaultItem,
                permission: defaultItem.permission?.map(defaultPerm => {
                    const existingPerm = existingItem.permission?.[0];
                    return {
                        ...defaultPerm,
                        read: {
                            ...defaultPerm.read,
                            allowed: existingPerm?.read || false
                        },
                        write: {
                            ...defaultPerm.write,
                            allowed: existingPerm?.write || false
                        },
                        delete: {
                            ...defaultPerm.delete,
                            allowed: existingPerm?.delete || false
                        }
                    };
                }),
                child: defaultItem.child?.map((defaultChild, childIndex) => {
                    const existingChild = existingItem.child?.[childIndex];
                    return {
                        ...defaultChild,
                        permission: defaultChild.permission?.map(defaultChildPerm => {
                            const existingChildPerm = existingChild?.permission?.[0];
                            return {
                                ...defaultChildPerm,
                                read: {
                                    ...defaultChildPerm.read,
                                    allowed: existingChildPerm?.read || false
                                },
                                write: {
                                    ...defaultChildPerm.write,
                                    allowed: existingChildPerm?.write || false
                                },
                                delete: {
                                    ...defaultChildPerm.delete,
                                    allowed: existingChildPerm?.delete || false
                                }
                            };
                        })
                    };
                })
            };
        });
    };

    if (isLoading) {
        return (
            <div className="flex items-center justify-center h-screen">
                <div className="flex flex-col items-center">
                    <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
                    <p className="mt-2 text-gray-600">Loading role data...</p>
                </div>
            </div>
        );
    }

    return (
        <div>
            <AddRole isEditMode={true} roleId={urlId} roleData={roleData} />
        </div>
    );
}

export default EditRole;
